/**
 * App chrome, English.
 *
 * Scope note: this covers the surfaces a saver sees on *every* screen — the tab
 * bar, the header, the account menu, the home quick actions and the page
 * titles. Screen bodies are still hardcoded English; they get pulled in here
 * screen by screen. Keys are grouped by surface so a translator can work
 * through one surface at a time rather than a flat wall of strings.
 */
export default {
  // Bottom tab bar
  'nav.home': 'Home',
  'nav.schemes': 'Schemes',
  'nav.pay': 'Pay',
  'nav.ledger': 'Ledger',
  'nav.account': 'Account',

  // Top app bar
  'header.notifications': 'Notifications',
  'header.notificationsUnread': 'Notifications, {{count}} unread',
  'header.back': 'Go back',
  'header.theme.toLight': 'Switch to light theme',
  'header.theme.toDark': 'Switch to dark theme',
  'header.language': 'Language',
  'header.language.en': 'English',
  'header.language.ml': 'Malayalam',

  // Home quick actions
  'quickActions.goals': 'Goals',
  'quickActions.redeem': 'Redeem',
  'quickActions.loans': 'Loans',
  'quickActions.complaints': 'Complaints',

  // Account menu + the page titles those rows lead to
  'account.profile': 'Profile & KYC',
  'account.ledger': 'Account Ledger',
  'account.goals': 'Goals & Milestones',
  'account.payments': 'Payment History',
  'account.redemptions': 'Redemptions',
  'account.loans': 'Jewellery Loans',
  'account.complaints': 'Complaints & Support',
  'account.notifications': 'Notifications',
  'account.settings': 'Settings',
  'account.help': 'Help & Support',

  // Page titles that are not account-menu rows
  'page.pay': 'Pay',
  'page.spin': 'Spin & Win',
  'page.spinGold': 'Gold Saver Spin'
};
